import React, { createContext, useContext, useEffect, useState } from "react";

export const FR = {
  nav: {
    villa: "La Villa",
    bungalow: "Le Bungalow",
    marina: "Le Marina",
    bassins: "Nos bassins",
    activites: "Activités",
    situation: "Situation",
    gallery: "Galerie",
    reviews: "Avis",
    booking: "Réservations",
    contact: "Contact",
    cta: "Réserver",
    menu: "Menu",
    close: "Fermer",
  },
  hero: {
    eyebrow: "Gourbeyre — Basse-Terre — Guadeloupe — Saison 2026-2027",
    titleA: "Villa Mana",
    titleB: "Miroir infini des Caraïbes.",
    titleC: "",
    sub: "Une éco-propriété de prestige en cours d'accréditation 5 étoiles accueillant de 2 à 16 personnes, posée sur les hauteurs de la marina de Rivière Sens. Vue mer exceptionnelle, piscine à débordement de 14 m, jacuzzi sur mesure, carbet - bar, parc tropical de 2 000 m².",
    badge: "Nouveau !",
    badgeSub: "Ouvert depuis le 1er juillet 2026",
    ctaPrimary: "Réserver en direct",
    ctaSecondary: "Découvrir la villa",
    scroll: "Découvrir",
  },
  marquee: [
    "Éco-villa de prestige",
    "Mer des Caraïbes",
    "Rivière Sens",
    "Guadeloupe",
    "Meublé de tourisme 5 ★",
    "Parc tropical",
  ],
  villa: {
    eyebrow: "La propriété",
    title: "Une propriété d'architecte éblouissante",
    p1: "Sortie d'une longue restauration entamée en 2023, la Propriété Villa Mana se dresse sur les petites hauteurs de la côte sous le vent, à 200 mètres de la marina de Rivière Sens. Elle réunit trois logements indépendants — La Villa (3 chambres), Le Bungalow (1 chambre) et Le Marina (2 chambres) — autour d'une piscine à débordement qui offre une vue à 180° sur la mer des Caraïbes ; la plage de sable noir est à 300 mètres.",
    p2: "Bois guadeloupéens travaillés par les meilleurs artisans locaux, matelas produits à Basse-Terre, électricité et eau chaude solaires, eau courante triplement filtrée : le grand confort y rencontre une empreinte carbone minimale.",
    stats: [
      { v: "3", l: "logements indépendants" },
      { v: "340 m²", l: "d'habitation" },
      { v: "6", l: "chambres doubles" },
      { v: "5", l: "salles de bain" },
      { v: "1", l: "piscine à débordement" },
      { v: "1", l: "jacuzzi" },
      { v: "1", l: "carbet-bar" },
      { v: "1", l: "plateforme de sport" },
      { v: "2 000 m²", l: "de parc tropical" },
      { v: "2 à 16", l: "voyageurs" },
      { v: "5 ★", l: "meublé de tourisme" },
    ],
    ecoTitle: "Une exigence éco-irréprochable",
    eco: [
      { t: "Solaire", d: "Électricité et eau chaude produites par le soleil antillais, stockées sur place." },
      { t: "Bois de Guadeloupe", d: "Rénovation en essences locales, façonnées sur place par des artisans." },
      { t: "Fraîcheur passive", d: "Vitres miroir et brasseurs plafonniers qui soulagent la climatisation." },
      { t: "Eau préservée", d: "Cuve de réserve assurant une eau courante triplement filtrée, sans coupure." },
    ],
    lodgingTitle: "Trois logements, une seule intimité",
    lodgingNote: [
      "La Propriété Villa Mana compte trois logements : La Villa, Le Bungalow et Le Marina. Ils se louent séparément ou se combinent astucieusement pour accueillir votre famille et vos amis.",
      "Quelle que soit la formule, votre location est intégrale et entièrement privative : piscine à débordement, jacuzzi, parc tropical et carbet ne sont jamais partagés, vous ne croisez aucun autre client.",
      "De 2 à 12 personnes en grand confort, jusqu'à 16 avec canapés-lits d'appoint.",
    ],
    lodgings: [
      { name: "La Villa", spec: "3 chambres dont une suite parentale · 180 m² · 6–8 pers. · Meublé de tourisme 5 ★", d: "Salon avec piano, grande cuisine équipée, immense galerie couverte, carbet-bar, piscine à débordement et jacuzzi privatifs." },
      { name: "Le Bungalow", spec: "1 suite · 60 m² · 2 pers. · accès piscine & jacuzzi · Meublé de tourisme 5 ★", d: "Une suite indépendante au cœur du parc tropical, avec accès privatif à la piscine et au jacuzzi." },
      { name: "Le Marina", spec: "Appartement indépendant · 2 chambres dont 1 suite · 100 m² · 4–6 pers. · Meublé de tourisme 4 ★", d: "Un appartement autonome pour un séjour libre, au plus près de la marina. Sans accès à la piscine ni au jacuzzi — sauf location combinée avec La Villa ou Le Bungalow." },
    ],
    labels: [
      "Meublé de tourisme 5 ★ — en cours d'accréditation",
      "Airbnb Superhost 2026",
      "Coup de cœur des voyageurs 2026",
      "Label européen Odyssea 2026",
    ],
    labelsTitle: "Nos labels & accréditations",
  },
  lavilla: {
    eyebrow: "Les logements",
    title: "La Villa",
    spec: "3 chambres dont une suite parentale · 180 m² · 6–8 personnes · Meublé de tourisme 5 ★",
    p1: "Le logement le plus grand de la Propriété Villa Mana : 3 chambres doubles dont une suite parentale assortie d'un canapé-lit d'appoint, un salon décoré avec piano et coin TV, une grande cuisine équipée et une immense galerie couverte.",
    p2: "Un carbet-bar et, bien sûr, une éblouissante piscine à débordement avec jacuzzi intégré complètent l'ensemble. Comme dans tous nos logements, les vitres miroir isolent les chambres de la chaleur et les brasseurs plafonniers ventilent chaque pièce : la vue sur la mer des Caraïbes vous accompagne à chaque instant du séjour.",
    features: [
      { t: "Suite parentale", d: "3 chambres doubles dont une suite avec canapé-lit d'appoint : 6 à 8 couchages." },
      { t: "Salon au piano", d: "Un salon décoré avec piano et coin TV, ouvert sur une grande cuisine équipée." },
      { t: "Galerie & carbet-bar", d: "Une immense galerie couverte et son carbet-bar pour les soirées face à la mer." },
      { t: "Piscine & jacuzzi", d: "Une éblouissante piscine à débordement avec jacuzzi intégré, vue mer des Caraïbes." },
    ],
    cta: "Réserver ce logement en direct",
  },
  bungalow: {
    eyebrow: "Les logements",
    title: "Le Bungalow",
    spec: "1 suite parentale · 60 m² · 1–2 personnes · Meublé de tourisme 5 ★",
    p1: "Le logement le plus singulier de la propriété : une suite parentale qui a littéralement les pieds dans la piscine. Un lit double de 180 cm face à la piscine et à la mer, l'accès direct au deck, un grand placard dressing et un petit bureau-coiffeuse.",
    p2: "Une salle d'eau avec douche italienne et vue mer, un wc privatif séparé et une kitchenette complètent la suite. Le Bungalow bénéficie en outre de l'accès privatif à l'espace carbet (hors bar) — canapés, barbecue à gaz, table à manger et baby-foot — ainsi qu'à la plateforme d'activités : relaxation, lecture, yoga. Il se loue seul, ou avec la Villa et/ou le Marina.",
    features: [
      { t: "Les pieds dans l'eau", d: "Lit double 180 cm avec vue piscine et mer, accès direct au deck." },
      { t: "Carbet privatif", d: "Canapés, barbecue à gaz, table à manger et baby-foot, réservés à vous seuls." },
      { t: "Salle d'eau vue mer", d: "Douche italienne, simple vasque, et wc privatif séparé." },
      { t: "Kitchenette & jardin", d: "60 m² pensés pour deux, au cœur du grand jardin tropical." },
    ],
    photos: [
      { id: "a83414_91c2e2db58384655a2f881776b2d08bd~mv2.png" },
      { id: "a83414_a406aef75f294dc888bf4a469d37abbb~mv2.png" },
      { id: "a83414_c1b1106977714975a73839e1710d7d3b~mv2.png" },
    ],
    cta: "Réserver ce logement en direct",
  },
  marina: {
    eyebrow: "Les logements",
    title: "Le Marina",
    spec: "Appartement indépendant · 2 chambres · 100 m² · 4–6 personnes · Meublé de tourisme 4 ★",
    p1: "L'éco-appartement haut de gamme de la propriété : doté de son entrée privée, il se loue indépendamment de la Villa et du Bungalow — ou avec eux. Seule précision : il n'a pas d'accès à la piscine ni au jacuzzi, sauf lorsqu'il est loué avec La Villa ou Le Bungalow.",
    p2: "Sa terrasse couverte privative de 40 m² offre une vue à couper le souffle sur la mer des Caraïbes et ses couchers de soleil ; canapés et hamac invitent à la détente, bercés par le débordement de la piscine de la Villa, à l'étage supérieur. Le séjour lumineux s'ouvre sur une cuisine moderne entièrement équipée, doublée d'une buanderie-lingerie et d'un wc indépendant. Le tout décoré de superbes couleurs locales.",
    features: [
      { t: "Suite Bologne", d: "Lit double 160 cm vue mer, accès direct terrasse, dressing, douche italienne, double vasque." },
      { t: "Chambre Terre de Bas", d: "Lit 180 cm (convertible en 2 × 90 sur demande), vue mer, salle de bain à baignoire-îlot." },
      { t: "Cuisine équipée", d: "Frigo, congélateur, four, micro-ondes, lave-vaisselle, robot, lave-linge." },
      { t: "Jardin tropical privatif", d: "L'accès se fait par un escalier bordé d'un jardin tropical privatif." },
    ],
    photos: [
      { id: "a83414_57300714aba44b979de7b539e084aed5~mv2.jpeg" },
      { id: "a83414_ec883bebbdab422caaf62ecfd961f92c~mv2.jpg" },
      { id: "a83414_55ee8d07d5004efd81c594287c79de98~mv2.jpeg" },
    ],
    cta: "Réserver ce logement en direct",
  },
  piscine: {
    eyebrow: "Nos bassins — La piscine",
    title: "Quatorze mètres face aux Caraïbes",
    paras: [
      "L'une des plus remarquables piscines à débordement du Sud Basse-Terre, en toute intimité, face à la mer des Caraïbes.",
      "14 mètres sur 3, avec plage de mise à l'eau, bancs sous-marins et un grand bassin fosse de 3 mètres. Son débordement surplombe Le Marina d'un ruissellement apaisant, et depuis les canapés du carbet, son niveau se confond avec la mer. Non chauffée, elle évolue naturellement entre 25 et 31 °C.",
    ],
    stats: [
      { v: "14 × 3 m", l: "de longueur × largeur" },
      { v: "3 m", l: "de profondeur au grand bassin" },
      { v: "25–31 °C", l: "naturellement, sans chauffage" },
      { v: "4 m", l: "de débordement au-dessus du Marina" },
    ],
  },
  jacuzzi: {
    eyebrow: "Nos bassins — Le jacuzzi",
    title: "Une petite machine à gravité heureuse",
    paras: [
      "Un jacuzzi de 5 places coulé sur le bord de la fosse : la vue porte à la fois sur la mer des Caraïbes à l'ouest et sur les Monts Caraïbes au sud.",
      "L'angulation de ses dossiers reprend la célèbre chaise Adirondack (1903) : assise inclinée, angle ouvert de 110°, corps « ancré », regard vers l'horizon.",
    ],
    solar: "Légèrement chauffé par nos panneaux solaires : 35 °C en permanence. Vous n'en sortirez plus !",
    schemaAngle: "110°",
    schemaHip: "hanches sous les genoux",
    schemaGaze: "regard vers l'horizon",
    schemaCaption: "Le principe de l'assise — chaise Adirondack, 1903",
  },
  situation: {
    eyebrow: "La situation",
    title: "Au cœur du Sud Basse-Terre, portes de la côte sous le vent",
    intro: "Posée sur les petites hauteurs de la côte sous le vent, la Villa Mana se trouve à 200 m de la marina de Rivière Sens, à 300 m d'une belle plage de sable noir et à 5 minutes à pied des commerces et restaurants. Et ici, presque jamais de sargasses.",
    benchmarks: [
      "Marina de Rivière Sens — 200 m",
      "Plage de sable noir — 300 m",
      "Commerces & restaurants — 5 min à pied",
      "Sentiers de randonnée — depuis la villa",
    ],
    mapCaption: "La propriété, en or, domine la marina — plage de sable noir et commerces à quelques minutes à pied.",
    itinerary: "Ouvrir l'itinéraire",
    sudTitle: "Le Sud Basse-Terre, au départ de la villa",
    nordTitle: "Le Nord Basse-Terre, en remontant la côte",
    sud: [
      { t: "Marina & plage de Rivière Sens", d: "Baignade sur la plage de sable noir, restaurants et activités nautiques à quelques minutes à pied." },
      { t: "Infini Plongée — notre recommandation spéciale", d: "Le club de plongée de la marina de Rivière Sens, à 200 m de la villa. Baptêmes, formations et sorties en mer encadrées par une équipe passionnée, qui fait découvrir les fonds caraïbes aux grands et aux petits." },
      { t: "Sources chaudes de Dolé", d: "Bains thermaux naturels à Gourbeyre, réputés pour leurs vertus apaisantes." },
      { t: "Houëlmont & Monts Caraïbes", d: "Sentiers de randonnée dont les départs se font depuis la villa, vues sur les Saintes." },
      { t: "Basse-Terre, ville d'histoire", d: "Marché coloré, fort Delgrès et cathédrale, à quelques minutes en voiture." },
      { t: "La Soufrière", d: "Ascension de la « vieille dame » (1 467 m) au départ des Bains Jaunes, au cœur du Parc national." },
      { t: "Bains Jaunes", d: "Bassin thermal naturel au pied de la Soufrière, sur les hauteurs de Saint-Claude." },
      { t: "Chutes du Carbet", d: "Les plus hautes chutes de l'île, à Capesterre-Belle-Eau ; deuxième chute à 45 minutes de marche." },
      { t: "Trois-Rivières & Vieux-Fort", d: "Plage de Grande-Anse, parc des Roches gravées et phare de Vieux-Fort face aux Saintes." },
      { t: "Embarcadère de Trois-Rivières — vers les Saintes", d: "À 25 minutes de la villa, l'embarcadère de Trois-Rivières est le point de départ vers les Saintes : la baie de Pain de sucre, la plage de Pompierre et le bourg coloré — une journée d'île en île, au fil de l'eau." },
    ],
    nord: [
      { t: "Réserve Cousteau", d: "Plongée et snorkeling face aux îlets Pigeon, depuis la plage de Malendure, à Bouillante." },
      { t: "Jardin botanique de Deshaies", d: "Cinq hectares de jardin tropical et plus de 1 000 espèces végétales." },
      { t: "Zoo de Guadeloupe", d: "Parc des Mamelles, sur la Route de la Traversée : 85 espèces et passerelles dans la canopée." },
      { t: "Route de la Traversée", d: "La traversée de la montagne et ses haltes naturelles : Cascade aux Écrevisses, Saut de la Lézarde." },
      { t: "Plage de Grande Anse, Deshaies", d: "Sable doré, paddle et l'un des plus beaux couchers de soleil de l'île." },
      { t: "Observation des cétacés", d: "Excursions en mer au départ de Deshaies et de Bouillante." },
    ],
  },
  gallery: {
    eyebrow: "Galerie",
    title: "La lumière des Caraïbes",
    caption: "Cliquer pour agrandir",
  },
  galleryItems: [
    { id: "/images/logements/villa/04-vue-drone-1.jpg", cap: "La propriété vue du ciel" },
    { id: "/images/logements/villa/01-piscine-debordement.jpg", cap: "La piscine à débordement" },
    { id: "/images/logements/villa/03-galerie-couverte.jpg", cap: "La galerie couverte" },
    { id: "/images/logements/villa/15-terrasse-repas-2.jpg", cap: "La terrasse face à la mer" },
    { id: "/images/logements/villa/40-bar-tiki.jpg", cap: "Le bar tiki" },
    { id: "/images/logements/villa/20-suite-soufriere.jpg", cap: "La suite Soufrière" },
    { id: "/images/logements/villa/37-terrasse-hamac.jpg", cap: "Le hamac face aux Caraïbes" },
    { id: "/images/logements/villa/09-carbet-balancoire.jpg", cap: "Les balançoires du carbet" },
    { id: "/images/logements/villa/08-piscine-aerienne.jpg", cap: "La piscine vue du ciel" },
    { id: "/images/logements/villa/06-vue-drone-3.jpg", cap: "2 000 m² de parc tropical" },
  ],
  reviews: {
    eyebrow: "Avis",
    title: "Ils sont venus, ils reviennent",
    google: "Note Google",
    airbnbTitle: "Avis Airbnb",
    googleTitle: "Avis Google",
    mixedCount: "avis sur Google & Airbnb",
    seeMore: "Voir la fiche Google",
  },
  reviewItems: [
    {
      q: "Superbe propriété pleine de charme et invitant à la détente. Tout est prévu pour les enfants, la piscine est juste sensationnelle, le débordement avec vue sur la mer des Caraïbes et ce coucher de soleil.",
      by: "Skwal Foster",
      src: "Google",
    },
    {
      q: "Une villa comme on n'en trouve pas deux ! Une vue exceptionnelle ! Un coucher de soleil à en tomber !",
      by: "Sylvain Séné",
      src: "Google",
    },
    {
      q: "Séjour incroyable dans cette villa en Guadeloupe ! La maison est magnifique, très propre, bien équipée et décorée avec goût. La vue est superbe et l'endroit est parfait pour se détendre au calme.",
      by: "Alison Magliozzi",
      src: "Google",
    },
    {
      q: "Séjour INCROYABLE, villa magnifique. Une fois dedans on ne veut plus en sortir. Il y a tout le confort nécessaire, la vue est idyllique, les installations, la literie… bref nous avons passé un super séjour en famille ! Notre hôte était très agréable, serviable et à disposition quand nous avions des questions. Nous y retournerons !",
      by: "Marjorie Laquitaine",
      src: "Google",
    },
    {
      q: "La villa est incroyable, très belle, bien propre, rien à dire.",
      by: "Julien Marcelin",
      src: "Google",
    },
    {
      q: "Il y a des avis qui ne reflètent pas du tout la réalité des lieux.",
      by: "Marchetti Jean-Christian",
      src: "Google",
    },
    {
      q: "Un séjour absolument incroyable de 4 jours à la Villa Mana ! Dès notre arrivée, nous avons été accueillis avec énormément de gentillesse et de professionnalisme. La villa est magnifique, très propre et parfaitement…",
      by: "Tiffany Yg",
      src: "Google",
    },
    {
      q: "Nous avons passé des vacances inoubliables dans cette magnifique villa. Tout était réuni pour que l'on se sente bien. L'emplacement est idéal pour rayonner et découvrir la Guadeloupe. Un grand merci aux hôtes pour leur accueil chaleureux, leur réactivité et leurs précieux conseils. Nous reviendrons sans hésiter !",
      by: "Arnaud",
      src: "Google",
    },
    {
      q: "Super séjour à La Villa Mana ! Le logement est superbe, très propre, confortable et parfaitement équipé. La piscine et le jacuzzi sont un vrai plus pour se détendre et profiter pleinement du séjour. L'endroit est calme, agréable et décoré…",
      by: "Marion Padieu",
      src: "Google",
    },
    {
      q: "Villa magnifique, tout est parfait : une vue imprenable, un coucher de soleil incroyable, la piscine ainsi que son jacuzzi, que du bonheur. Nous avons passé un très bon moment paisible, nous reviendrons.",
      by: "Celine Raviart",
      src: "Google",
    },
    {
      q: "On s'y sent immédiatement comme chez soi, avec une ambiance à la fois luxueuse et chaleureuse. Chaque espace est pensé pour se détendre et profiter pleinement du moment.",
      by: "Séjour de 4 jours",
      src: "Avis vérifié",
    },
  ],
  booking: {
    eyebrow: "Réservations",
    title: "Le meilleur tarif est ici, sans commission",
    intro: "Réservez directement auprès de nous, en toute simplicité : aucun intermédiaire, aucune commission — votre séjour est simplement plus avantageux, et nos calendriers de disponibilités sont tenus à jour en temps réel.",
    opt1: "Réserver par dates de séjour",
    checkin: "Arrivée",
    checkout: "Départ",
    guests: "Voyageurs",
    search: "Voir les disponibilités",
    widgetNote: "Recherchez vos dates et vos voyageurs : les résultats s'ouvrent dans notre module de réservation sécurisé.",
    calendarTitle: "Réserver en direct, en 2 minutes",
    calendarNote: "Choisissez votre logement, sélectionnez vos dates dans le calendrier, puis finalisez avec le paiement sécurisé par carte.",
    opt2: "Réserver par logement",
    choose: "Voir ce logement",
    paymentTitle: "Une réservation de qualité hôtelière",
    payments: [
      "Pré-autorisation de 0 € sur carte bancaire",
      "30 % d'arrhes à l'acceptation de la réservation",
      "Solde débité 1 mois avant l'arrivée",
      "Caution non débitée : 300 € (Marina, Bungalow) · 500 € (Villa 3–4 ch.) · 800 € (Villa 6 ch.)",
    ],
    formTitle: "Vous pouvez aussi nous parler de votre projet !",
    formNote: "Réponse assurée, en général le jour même.",
    name: "Nom et prénom",
    email: "Email",
    phone: "Téléphone (facultatif)",
    guestsField: "Nombre de voyageurs",
    message: "Message (facultatif)",
    submit: "Envoyer la demande",
    success: "Demande envoyée — nous revenons vers vous très vite.",
    error: "Une erreur est survenue. Écrivez-nous à villamana971@gmail.com.",
    privacy: "Entièrement privatif : quelle que soit la formule choisie, vous ne partagez rien et vous ne croisez personne. Seule nuance : loué seul, Le Marina n'ouvre pas l'accès à la piscine ni au jacuzzi — privilège des formules avec La Villa ou Le Bungalow.",
    comboNote: "Villa 4 chambres = La Villa + Le Bungalow · Villa complète 6 chambres = toute la propriété. Chaque formule reste intégralement privative.",
    amenitiesTitle: "Les équipements de ce logement",
    amenitiesMore: "+ Voir tous les équipements",
    amenitiesLess: "− Réduire",
  },
  contact: {
    eyebrow: "Contact",
    title: "Vous êtes bienvenus.",
    access: "Séjours, évènements calmes, réunions familiales, Day Pass d'accès à nos bassins, shootings, nous sommes à votre écoute.",
    address: "4 rue de la Poudrière, 97113 Gourbeyre, Guadeloupe — French West Indies",
    whatsapp: "WhatsApp",
    follow: "Suivre la villa",
    backTop: "Haut de page",
    rights: "Tous droits réservés",
  },
  legal: {
    eyebrow: "Informations légales",
    title: "Mentions légales",
    editorTitle: "Éditeur du site",
    editorBody:
      "MELIN — Alexandre, entrepreneur individuel · SIRET 882 879 406 00016 · APE 55.20Z (hébergement touristique) · 4 rue de la Poudrière, 97113 Gourbeyre, Guadeloupe · villamana971@gmail.com · +590 690 32 47 77.",
    publishingDirector: "Directeur de la publication : Alexandre.",
    hostingTitle: "Hébergement",
    hostingBody:
      "Le site est hébergé par Emergent (emergent.sh). Contact de l'hébergeur via l'éditeur ci-dessus.",
    ipTitle: "Propriété intellectuelle",
    ipBody:
      "L'ensemble des textes, photos et éléments graphiques du site est protégé. Toute reproduction, même partielle, sans autorisation écrite préalable est interdite.",
    creditsTitle: "Crédits photos",
    creditsOwner:
      "Photographies de la propriété et des logements : © MELIN — Villa Mana. Tous droits réservés.",
    creditsWikimedia:
      "Photo de la baie de Terre-de-Haut (activité « Embarcadère de Trois-Rivières — vers les Saintes ») : Sonnate,",
    creditsWikimediaLink:
      "CC BY-SA 4.0, via Wikimedia Commons",
    dataTitle: "Données personnelles",
    dataBody:
      "Les informations transmises via le formulaire de réservation (nom, email, téléphone, dates) servent exclusivement à traiter votre demande. Vous pouvez demander leur suppression par email à villamana971@gmail.com.",
  },
};

export const EN = {
  nav: {
    villa: "The Villa",
    bungalow: "The Bungalow",
    marina: "The Marina",
    bassins: "Our pools",
    activites: "Activities",
    situation: "Location",
    gallery: "Gallery",
    reviews: "Reviews",
    booking: "Bookings",
    contact: "Contact",
    cta: "Book",
    menu: "Menu",
    close: "Close",
  },
  hero: {
    eyebrow: "Gourbeyre — Basse-Terre — Guadeloupe — Season 2026-2027",
    titleA: "Villa Mana",
    titleB: "Infinite mirror of the Caribbean.",
    titleC: "",
    sub: "A 5-star prestige eco-estate, accreditation in progress, welcoming 2 to 16 guests, set on the heights of Rivière Sens marina. Exceptional sea view, 14 m infinity pool, bespoke jacuzzi, carbet bar, 2,000 m² tropical park.",
    badge: "New!",
    badgeSub: "Open since July 1st, 2026",
    ctaPrimary: "Book direct",
    ctaSecondary: "Discover the villa",
    scroll: "Discover",
  },
  marquee: [
    "Prestige eco-villa",
    "Caribbean Sea",
    "Rivière Sens",
    "Guadeloupe",
    "5 ★ tourist accommodation",
    "Tropical park",
  ],
  villa: {
    eyebrow: "The estate",
    title: "A dazzling architect's estate",
    p1: "Emerging from a long restoration begun in 2023, the Villa Mana estate stands on the gentle heights of the windward coast, 200 metres from Rivière Sens marina. It brings together three independent homes — The Villa (3 bedrooms), The Bungalow (1 bedroom) and The Marina (2 bedrooms) — around an infinity pool with a 180° view of the Caribbean Sea; the black-sand beach lies 300 metres away.",
    p2: "Guadeloupean woods shaped by the finest local craftsmen, mattresses made in Basse-Terre, solar electricity and hot water, triple-filtered running water: grand comfort with a minimal carbon footprint.",
    stats: [
      { v: "3", l: "independent homes" },
      { v: "340 m²", l: "of living space" },
      { v: "6", l: "double bedrooms" },
      { v: "5", l: "bathrooms" },
      { v: "1", l: "infinity pool" },
      { v: "1", l: "jacuzzi" },
      { v: "1", l: "carbet-bar" },
      { v: "1", l: "sports platform" },
      { v: "2,000 m²", l: "tropical park" },
      { v: "2 to 16", l: "guests" },
      { v: "5 ★", l: "rated accommodation" },
    ],
    ecoTitle: "An impeccable eco standard",
    eco: [
      { t: "Solar", d: "Electricity and hot water produced by the Caribbean sun, stored on site." },
      { t: "Guadeloupean wood", d: "Renovation in local species, crafted on site by artisans." },
      { t: "Passive cool", d: "Mirror glazing and ceiling fans that spare the air conditioning." },
      { t: "Water preserved", d: "Reserve tank delivering triple-filtered running water, without outage." },
    ],
    lodgingTitle: "Three homes, one single intimacy",
    lodgingNote: [
      "The Villa Mana estate counts three homes: The Villa, The Bungalow and The Marina. They can be rented separately or cleverly combined to welcome your family and friends.",
      "Whatever the formula, your rental is integral and fully private: the infinity pool, jacuzzi, tropical park and carbet are never shared, and you will not come across any other guests.",
      "From 2 to 12 guests in great comfort, up to 16 with extra sofa beds.",
    ],
    lodgings: [
      { name: "The Villa", spec: "3 bedrooms incl. a master suite · 180 m² · 6–8 guests · 5 ★ rated", d: "Living room with piano, large fitted kitchen, vast covered gallery, carbet-bar, private infinity pool and jacuzzi." },
      { name: "The Bungalow", spec: "1 suite · 60 m² · 2 guests · pool & jacuzzi access · 5 ★ rated", d: "A standalone suite in the heart of the tropical park, with private access to the pool and jacuzzi." },
      { name: "The Marina", spec: "Independent apartment · 2 bedrooms incl. 1 suite · 100 m² · 4–6 guests · 4 ★ rated", d: "A self-contained apartment for a free-spirited stay, steps from Rivière Sens marina. No pool or jacuzzi access — unless rented together with The Villa or The Bungalow." },
    ],
    labels: [
      "5 ★ tourist accommodation — accreditation in progress",
      "Airbnb Superhost 2026",
      "Travelers' favorite 2026",
      "European Odyssea label 2026",
    ],
    labelsTitle: "Our labels & accreditations",
  },
  lavilla: {
    eyebrow: "The homes",
    title: "The Villa",
    spec: "3 bedrooms incl. a master suite · 180 m² · 6–8 guests · 5 ★ rated",
    p1: "The largest home of the Villa Mana estate: 3 double bedrooms including a master suite with a sofa bed, a living room decorated with a piano and TV corner, a large fitted kitchen and a vast covered gallery.",
    p2: "A carbet-bar and, of course, a dazzling infinity pool with integrated jacuzzi complete the ensemble. As in all our homes, mirror glazing keeps the bedrooms cool and ceiling fans ventilate every room: the view of the Caribbean Sea accompanies you throughout your stay.",
    features: [
      { t: "Master suite", d: "3 double bedrooms incl. a suite with sofa bed: 6 to 8 guests." },
      { t: "Piano living room", d: "A living room with piano and TV corner, opening onto a large fitted kitchen." },
      { t: "Gallery & carbet-bar", d: "A vast covered gallery and its carbet-bar for evenings facing the sea." },
      { t: "Pool & jacuzzi", d: "A dazzling infinity pool with integrated jacuzzi, facing the Caribbean Sea." },
    ],
    cta: "Book this home direct",
  },
  bungalow: {
    eyebrow: "The homes",
    title: "The Bungalow",
    spec: "1 master suite · 60 m² · 1–2 guests · 5 ★ rated",
    p1: "The most singular home of the estate: a master suite literally with its feet in the pool. A 180 cm double bed facing the pool and the sea, direct access to the deck, a large dressing closet and a small desk-dressing table.",
    p2: "A shower room with walk-in shower and sea view, a separate private toilet and a kitchenette complete the suite. The Bungalow also enjoys private access to the carbet space (bar excluded) — sofas, gas barbecue, dining table and table football — as well as the activity platform for relaxation, reading and yoga. It can be rented alone, or with the Villa and/or the Marina.",
    features: [
      { t: "Feet in the water", d: "A 180 cm double bed with pool and sea view, direct deck access." },
      { t: "Private carbet", d: "Sofas, gas barbecue, dining table and table football, all to yourselves." },
      { t: "Sea-view shower room", d: "Walk-in shower, single basin, and a separate private toilet." },
      { t: "Kitchenette & garden", d: "60 m² designed for two, in the heart of the grand tropical garden." },
    ],
    photos: [
      { id: "a83414_91c2e2db58384655a2f881776b2d08bd~mv2.png" },
      { id: "a83414_a406aef75f294dc888bf4a469d37abbb~mv2.png" },
      { id: "a83414_c1b1106977714975a73839e1710d7d3b~mv2.png" },
    ],
    cta: "Book this home direct",
  },
  marina: {
    eyebrow: "The homes",
    title: "The Marina",
    spec: "Independent apartment · 2 bedrooms · 100 m² · 4–6 guests · 4 ★ rated",
    p1: "The estate's high-end eco-apartment: with its own private entrance, it can be rented independently of the Villa and the Bungalow — or together with them. One note: it has no access to the pool or jacuzzi unless rented together with The Villa or The Bungalow.",
    p2: "Its 40 m² private covered terrace overlooks the Caribbean Sea and its breathtaking sunsets; sofas and a hammock invite pure relaxation, lulled by the soft overflow of the villa's pool on the floor above. The bright living room opens onto a fully equipped modern kitchen, a laundry room and an independent toilet — all dressed in superb local colours.",
    features: [
      { t: "Suite Bologne", d: "160 cm double bed with sea view, direct terrace access, dressing, walk-in shower, double basin." },
      { t: "Chambre Terre de Bas", d: "180 cm double bed (convertible into two 90 cm singles on request), sea view, bathtub." },
      { t: "Equipped kitchen", d: "Fridge, freezer, oven, microwave, dishwasher, food processor, washing machine." },
      { t: "Private tropical garden", d: "Access is via a staircase lined with a private tropical garden." },
    ],
    photos: [
      { id: "a83414_57300714aba44b979de7b539e084aed5~mv2.jpeg" },
      { id: "a83414_ec883bebbdab422caaf62ecfd961f92c~mv2.jpg" },
      { id: "a83414_55ee8d07d5004efd81c594287c79de98~mv2.jpeg" },
    ],
    cta: "Book this home direct",
  },
  piscine: {
    eyebrow: "Our pools — The pool",
    title: "Fourteen metres facing the Caribbean",
    paras: [
      "One of the most remarkable infinity pools in southern Basse-Terre, in complete privacy, facing the Caribbean Sea.",
      "14 by 3 metres, with a sun shelf, underwater benches and a 3-metre-deep tank. Its infinity edge overlooks the Marina with a soothing trickle, and from the carbet sofas its level merges with the sea. Unheated, it sits naturally between 25 and 31°C.",
    ],
    stats: [
      { v: "14 × 3 m", l: "length × width" },
      { v: "3 m", l: "deep in the main tank" },
      { v: "25–31 °C", l: "naturally, unheated" },
      { v: "4 m", l: "infinity edge above the Marina" },
    ],
  },
  jacuzzi: {
    eyebrow: "Our pools — The jacuzzi",
    title: "A little happy-gravity machine",
    paras: [
      "A 5-seat jacuzzi cast into the edge of the pool's tank: the view reaches both the Caribbean Sea to the west and the Monts Caraïbes peaks to the south.",
      "Its backrests replicate the famous Adirondack chair (1903): a reclined seat, an open 110° angle, an 'anchored' body, eyes on the horizon.",
    ],
    solar: "Gently heated by our solar panels: a constant 35°C. You won't want to get out!",
    schemaAngle: "110°",
    schemaHip: "hips below the knees",
    schemaGaze: "gaze on the horizon",
    schemaCaption: "The seating principle — Adirondack chair, 1903",
  },
  situation: {
    eyebrow: "The location",
    title: "In the heart of South Basse-Terre, gateway to the leeward coast",
    intro: "Set on the gentle heights of the leeward coast, Villa Mana lies 200 m from Rivière Sens marina, 300 m from a beautiful black-sand beach and a 5-minute walk from shops and restaurants. And sargassum almost never reaches this shore.",
    benchmarks: [
      "Rivière Sens marina — 200 m",
      "Black-sand beach — 300 m",
      "Shops & restaurants — 5-min walk",
      "Hiking trails — from the villa",
    ],
    mapCaption: "The estate, in gold, overlooks the marina — black-sand beach and shops a few minutes' walk away.",
    itinerary: "Open directions",
    sudTitle: "South Basse-Terre, starting from the villa",
    nordTitle: "North Basse-Terre, up the coast",
    sud: [
      { t: "Marina & beach of Rivière Sens", d: "Swim on the black-sand beach, dine out and set off on water activities within a few minutes' walk." },
      { t: "Infini Plongée — our special recommendation", d: "The dive club on Rivière Sens marina, 200 m from the villa. Intro dives, courses and supervised sea outings with a passionate team that shows guests of all ages the Caribbean underwater world." },
      { t: "Dolé hot springs", d: "Natural thermal baths in Gourbeyre, famed for their soothing virtues." },
      { t: "Houëlmont & Monts Caraïbes", d: "Hiking trails starting from the villa, with views over Les Saintes." },
      { t: "Basse-Terre, a town of history", d: "The colourful market, Fort Delgrès and the cathedral, a few minutes by car." },
      { t: "La Soufrière", d: "Climb the 'old lady' (1,467 m) from the Bains Jaunes, deep in the National Park." },
      { t: "Bains Jaunes", d: "A natural thermal pool at the foot of La Soufrière, above Saint-Claude." },
      { t: "Carbet Falls", d: "The island's highest falls, in Capesterre-Belle-Eau; the second cascade is a 45-minute walk." },
      { t: "Trois-Rivières & Vieux-Fort", d: "Grande-Anse beach, the petroglyph park and Vieux-Fort lighthouse facing Les Saintes." },
      { t: "Trois-Rivières dock — on to Les Saintes", d: "25 minutes from the villa, the Trois-Rivières terminal is the gateway to Les Saintes: Pain de sucre bay, Pompierre beach and the colourful village — an island-hopping day on the water." },
    ],
    nord: [
      { t: "Cousteau Reserve", d: "Diving and snorkelling facing the Pigeon islets, from Malendure beach in Bouillante." },
      { t: "Deshaies Botanical Garden", d: "Five hectares of tropical garden with over 1,000 plant species." },
      { t: "Guadeloupe Zoo", d: "Parc des Mamelles, on the Route de la Traversée: 85 species and canopy walkways." },
      { t: "Route de la Traversée", d: "The mountain crossing and its natural stops: Cascade aux Écrevisses, Saut de la Lézarde." },
      { t: "Grande Anse beach, Deshaies", d: "Golden sand, paddleboarding and one of the island's finest sunsets." },
      { t: "Whale watching", d: "Sea excursions departing from Deshaies and Bouillante." },
    ],
  },
  gallery: {
    eyebrow: "Gallery",
    title: "The light of the Caribbean",
    caption: "Click to enlarge",
  },
  galleryItems: [
    { id: "/images/logements/villa/07-vue-drone-4.jpg", cap: "The estate from above" },
    { id: "/images/logements/villa/01-piscine-debordement.jpg", cap: "The infinity pool" },
    { id: "/images/logements/villa/03-galerie-couverte.jpg", cap: "The covered gallery" },
    { id: "/images/logements/villa/15-terrasse-repas-2.jpg", cap: "The sea-facing terrace" },
    { id: "/images/logements/villa/40-bar-tiki.jpg", cap: "The tiki bar" },
    { id: "/images/logements/villa/20-suite-soufriere.jpg", cap: "The Soufrière suite" },
    { id: "/images/logements/villa/37-terrasse-hamac.jpg", cap: "The hammock facing the Caribbean" },
    { id: "/images/logements/villa/09-carbet-balancoire.jpg", cap: "Carbet swings" },
    { id: "/images/logements/villa/08-piscine-aerienne.jpg", cap: "The pool from above" },
    { id: "/images/logements/villa/06-vue-drone-3.jpg", cap: "2,000 m² of tropical gardens" },
  ],
  reviews: {
    eyebrow: "Reviews",
    title: "They came, they return",
    google: "Google rating",
    airbnbTitle: "Airbnb reviews",
    googleTitle: "Google reviews",
    mixedCount: "reviews on Google & Airbnb",
    seeMore: "See the Google listing",
  },
  reviewItems: [
    {
      q: "A superb property full of charm, inviting pure relaxation. Everything is thought out for children, the pool is sensational — the infinity edge over the Caribbean Sea and that sunset.",
      by: "Skwal Foster",
      src: "Google",
    },
    {
      q: "A villa like no other! An exceptional view! A sunset to die for!",
      by: "Sylvain Séné",
      src: "Google",
    },
    {
      q: "Incredible stay in this villa in Guadeloupe! The house is beautiful, very clean, well equipped and tastefully decorated. The view is superb and the place is perfect for relaxing in peace.",
      by: "Alison Magliozzi",
      src: "Google",
    },
    {
      q: "INCREDIBLE stay, magnificent villa. Once inside, you never want to leave. All the comfort you need, the idyllic view, the facilities, the bedding… in short, we had a wonderful family stay! Our host was lovely, helpful and available whenever we had questions. We will be back!",
      by: "Marjorie Laquitaine",
      src: "Google",
    },
    {
      q: "The villa is incredible — beautiful, spotlessly clean, nothing to fault.",
      by: "Julien Marcelin",
      src: "Google",
    },
    {
      q: "There are reviews that don't reflect the reality of the place at all.",
      by: "Marchetti Jean-Christian",
      src: "Google",
    },
    {
      q: "An absolutely incredible 4-day stay at Villa Mana! From the moment we arrived, we were welcomed with tremendous kindness and professionalism. The villa is beautiful, very clean and perfectly…",
      by: "Tiffany Yg",
      src: "Google",
    },
    {
      q: "We had an unforgettable holiday in this magnificent villa. Everything was there to make us feel at home. The location is ideal for exploring and discovering Guadeloupe. Many thanks to our hosts for their warm welcome, their responsiveness and their precious advice. We will come back without hesitation!",
      by: "Arnaud",
      src: "Google",
    },
    {
      q: "A wonderful stay at La Villa Mana! The home is superb, very clean, comfortable and perfectly equipped. The pool and jacuzzi are a real plus for relaxing and making the most of the stay. The place is calm, pleasant and tastefully decorated…",
      by: "Marion Padieu",
      src: "Google",
    },
    {
      q: "Magnificent villa, everything is perfect: a breathtaking view, an incredible sunset, the pool and its jacuzzi — pure happiness. We spent a very peaceful moment, we will be back.",
      by: "Celine Raviart",
      src: "Google",
    },
    {
      q: "You feel at home immediately, in an atmosphere both luxurious and warm. Every space is designed to unwind and fully enjoy the moment.",
      by: "4-day stay",
      src: "Verified review",
    },
  ],
  booking: {
    eyebrow: "Bookings",
    title: "The best rate is here, commission-free",
    intro: "Book directly with us, effortlessly: no middleman, no commission — your stay is simply better value, and our availability calendars are updated in real time.",
    opt1: "Book by stay dates",
    checkin: "Check-in",
    checkout: "Check-out",
    guests: "Guests",
    search: "See availability",
    widgetNote: "Search your dates and party size: results open in our secure booking module.",
    calendarTitle: "Book direct, in 2 minutes",
    calendarNote: "Pick your home, select your dates in the calendar, then check out with secure card payment.",
    opt2: "Book by accommodation",
    choose: "View this home",
    paymentTitle: "Hotel-grade booking terms",
    payments: [
      "€0 card pre-authorisation",
      "30% deposit upon booking confirmation",
      "Balance charged 1 month before arrival",
      "Refundable deposit: €300 (Marina, Bungalow) · €500 (Villa 3–4 br) · €800 (Villa 6 br)",
    ],
    formTitle: "You can also tell us about your project!",
    formNote: "We answer quickly — usually the same day.",
    name: "Full name",
    email: "Email",
    phone: "Phone (optional)",
    guestsField: "Number of guests",
    message: "Message (optional)",
    submit: "Send request",
    success: "Request sent — we will get back to you very soon.",
    error: "Something went wrong. Write to us at villamana971@gmail.com.",
    privacy: "Fully private: whatever the formula you choose, you share nothing and meet no one. One note: when rented on its own, The Marina does not include access to the pool or the jacuzzi — reserved for the formulas with The Villa or The Bungalow.",
    comboNote: "4-bedroom Villa = The Villa + The Bungalow · full 6-bedroom Villa = the entire estate. Every formula remains fully private.",
    amenitiesTitle: "This home's amenities",
    amenitiesMore: "+ Show all amenities",
    amenitiesLess: "− Show less",
  },
  contact: {
    eyebrow: "Contact",
    title: "You are welcome.",
    access: "Stays, quiet events, family gatherings, Day Pass access to our pools, photo shoots — we are here to listen.",
    address: "4 rue de la Poudrière, 97113 Gourbeyre, Guadeloupe — French West Indies",
    whatsapp: "WhatsApp",
    follow: "Follow the villa",
    backTop: "Back to top",
    rights: "All rights reserved",
  },
  legal: {
    eyebrow: "Legal information",
    title: "Legal notice",
    editorTitle: "Site publisher",
    editorBody:
      "MELIN — Alexandre, sole proprietor · SIRET 882 879 406 00016 · APE 55.20Z (tourist accommodation) · 4 rue de la Poudrière, 97113 Gourbeyre, Guadeloupe, France · villamana971@gmail.com · +590 690 32 47 77.",
    publishingDirector: "Publishing director: Alexandre.",
    hostingTitle: "Hosting",
    hostingBody:
      "This website is hosted by Emergent (emergent.sh). Host contact via the publisher above.",
    ipTitle: "Intellectual property",
    ipBody:
      "All texts, photographs and graphic elements on this site are protected. Any reproduction, even partial, without prior written authorisation is prohibited.",
    creditsTitle: "Photo credits",
    creditsOwner:
      "Photographs of the property and lodgings: © MELIN — Villa Mana. All rights reserved.",
    creditsWikimedia:
      "Photo of Terre-de-Haut bay (activity “Embarcadère de Trois-Rivières — vers les Saintes”): Sonnate,",
    creditsWikimediaLink:
      "CC BY-SA 4.0, via Wikimedia Commons",
    dataTitle: "Personal data",
    dataBody:
      "The information submitted through the booking form (name, email, phone, dates) is used solely to process your enquiry. You may request its deletion by emailing villamana971@gmail.com.",
  },
};

export const AIRBNB_REVIEWS = [
  { q: "Super séjour chez Alex ! Piscine et vue exceptionnelles ! Emplacement au calme. Tout est réuni pour passer un excellent moment de détente et de convivialité. Alex est un hôte très sympathique, disponible et réactif. Tout était parfait ! Nous y retournerons avec grand plaisir !", by: "Patsy", fr: "Villa · 3 chambres", en: "Villa · 3 bedrooms", dateFr: "Août 2026", dateEn: "August 2026" },
  { q: "Un grand merci pour l'accueil et la qualité du logement partagé, c'est beau et raffiné, nous étions tous ravis et dépaysés.", by: "David", fr: "Villa · 3 chambres", en: "Villa · 3 bedrooms", dateFr: "Juillet 2026", dateEn: "July 2026" },
  { q: "Nous avons pu passé 1 nuit dans le logement, nous avons fait venir un chef à domicile. Le logement était parfait pour notre soirée. Le lieux est bien placé, la vue incroyable. Très propre et très fonctionnel. C'est sûr que nous reviendrons rapidement pour plus de jours. Hâte de revenir. Merci pour tout !", by: "Illitch", fr: "Villa · 4 chambres", en: "Villa · 4 bedrooms", dateFr: "Juillet 2026", dateEn: "July 2026" },
  { q: "Le séjour s'est extrêmement bien passé. Notre accueil a été très bien géré. La villa, son mobilier, ses équipements et surtout la vue sont magnifiques. Le sunset avec la piscine à débordement qui semble se verser dans l'océan est un must. Une très belle expérience que je vais sûrement renouveler l'an prochain.", by: "Anthony", fr: "Villa · 4 chambres", en: "Villa · 4 bedrooms", dateFr: "Juillet 2026", dateEn: "July 2026" },
  { q: "Magnifique endroit, vue spectaculaire, installations luxueuses et communication très fluide. Un sans faute ! J'ai déjà hâte d'y retourner !", by: "Charles", fr: "Le Bungalow", en: "The Bungalow", dateFr: "Juillet 2026", dateEn: "July 2026" },
  { q: "Merci 👌 c'était une expérience magique ! Tout était impeccable !! Gros coup de cœur pour notre belle Céline ! À bientôt les amis !", by: "Maxime", fr: "Le Bungalow", en: "The Bungalow", dateFr: "Juin 2026", dateEn: "June 2026" },
  { q: "Nous avons passé un excellent week-end dans le bungalow de la villa Mana. Nous étions avec des amis qui ont loué l'appartement le marina et c'était vraiment magnifique !! Nous avons déjà envie de revenir en espérant pouvoir aussi louer la partie villa mana. Alex a bien répondu à toutes mes questions et nous a fait un petit geste commercial pour mon anniversaire, la villa mana (que je voulais réserver à l'origine) étant fermée pour travaux. Le fait qu'une villa de cette qualité soit présente dans le SUD Basse-Terre avec possibilité de louer que 3 nuits était vraiment un grand plus pour moi ! MERCI", by: "Leslie", fr: "Le Bungalow", en: "The Bungalow", dateFr: "Juin 2026", dateEn: "June 2026" },
  { q: "Séjour d'exception dans un lieu d'exception, tout est dans le détail, la vue est époustouflante, la piscine est grande et profonde, le jacuzzi est chaud ce qui est agréable pour Basse-Terre, le bungalow est neuf et construit avec des matériaux de qualité. Équipe et propriétaire très réactifs. Bravo, je recommande très fortement.", by: "Alia", fr: "Le Bungalow", en: "The Bungalow", dateFr: "Mai 2026", dateEn: "May 2026" },
  { q: "Nous avons loué l'appartement le marina et le bungalow de la villa mana afin d'être en famille et entre amis pour mon anniversaire. Le séjour était excellent. L'emplacement et la vue parfaits et magnifiques !! C'était une fin de semaine paisible et pleine de bons moments pour moi ! Le fait que ce logement soit situé dans le SUD Basse-Terre et que l'on puisse louer 3 nuits seulement était vraiment un grand plus pour nous !!", by: "Leslie", fr: "Le Marina", en: "The Marina", dateFr: "Juin 2026", dateEn: "June 2026" },
  { q: "Excellent logement : spacieux, propre, fonctionnel… et la vue est incroyable !!! On s'y sent bien. L'hôte est très agréable et réactif. Nous avons beaucoup apprécié le séjour !", by: "Nilda", fr: "Le Marina", en: "The Marina", dateFr: "Mai 2026", dateEn: "May 2026" },
  { q: "Un appartement de rêve : très bien équipé et très propre, vue magnifique depuis la terrasse, accueil très chaleureux de la part de Céline ; par la suite également, Céline a répondu aux messages sans délai et s'est montrée très serviable. Parking privé juste devant l'appartement. Un choix de très bons restaurants et de délicieuses boulangeries ainsi qu'un petit supermarché à distance de marche, un supermarché plus grand rapidement accessible en voiture. Nous nous sommes sentis vraiment très à l'aise, nous avons trouvé tout ce dont nous avions besoin, en particulier dans la cuisine, et nous recommanderions sans hésiter le logement ou le réserverions à nouveau. Un grand merci aux hôtes !", by: "Martin", fr: "Le Marina", en: "The Marina", dateFr: "Avril 2026", dateEn: "April 2026" },
  { q: "Très beau logement avec des commodités parfaites. Les chambres étaient belles et confortables. Le patio, formidable !", by: "Julie", fr: "Le Marina", en: "The Marina", dateFr: "Avril 2026", dateEn: "April 2026" },
  { q: "Un endroit avec une vue imprenable. Tout est neuf et de bon goût. Très confortable. J'y retournerai sans aucun doute 💯", by: "Elyse", fr: "Le Marina", en: "The Marina", dateFr: "Avril 2026", dateEn: "April 2026" },
  { q: "Superbe séjour ! Magnifique maison haut de gamme, très confortable et immaculée. Très bien équipée à tous les niveaux. Tout est de qualité supérieure. Couchers de soleil inoubliables. Près de deux bonnes boulangeries, boucherie, fruiterie, épicerie. Bien située pour plusieurs randos, Soufrière, bassin bleu, rando littoral et pour aller aux Saintes. Merci pour l'accueil chaleureux de Céline et de ses bonnes recommandations.", by: "Marie-Andrée", fr: "Le Marina", en: "The Marina", dateFr: "Mars 2026", dateEn: "March 2026" },
];

const dictionaries = { fr: FR, en: EN };
const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("vm-lang");
    return saved === "en" || saved === "fr" ? saved : "fr";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("vm-lang", l);
    setLangState(l);
  };

  const value = { lang, setLang, t: dictionaries[lang], isFr: lang === "fr" };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
